
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Form as ElForm, Input } from 'element-ui';
import { toast } from '@/utils/common';
import { PublicQuery } from '@/mixins/public_query';
import Upload from '@/components/ImagesUpload/upload.vue';
import { iHotGameDetails, eEndPoint } from '@/interface/hot-game';
import { iSelectGameSearch, iSelectGame } from '@/interface/game-manage';
import { iUploadeImagesList } from '@/interface/imageUpload';
import { postAddHostGame, postEditHostGame } from '@/api/android';
import { getGameManage } from '@/api/game-manage';
@Component({
  components: { Upload },
})
export default class HotEdit extends Vue {
  @Prop() model!: iHotGameDetails;
  @Prop() enterImgUpload!: iUploadeImagesList[];
  @Prop() enterImg2Upload!: iUploadeImagesList[];
  @Prop() endpoint!: Number;
  private android = eEndPoint.ADNROID;
  private pc = eEndPoint.PC;
  private web = eEndPoint.WEB;
  private ios = eEndPoint.IOS;
  private loading = false;
  rules = {
    top_title: [
      { required: true, message: '请输入主标题,不超过120个字', trigger: 'blur' },
      { min: 1, max: 120, message: '长度在 1到 120 个字', trigger: 'blur' },
    ],
    sub_title: [
      { required: true, message: '请输入副标题,不超过120个字', trigger: 'blur' },
      { min: 1, max: 120, message: '长度在 1到 120 个字', trigger: 'blur' },
    ],
    game_id: [{ required: true, message: '请选择游戏', trigger: 'blur', validator: this.getGameId }],
    is_screen: [{ required: true, message: '请选择是否通屏', trigger: 'blur' }],
    enterImgUpload: [{ required: true, validator: this.getenterImgLength, trigger: 'blur' }],
  };
  gameList: iSelectGameSearch[] = [];

  getenterImgLength(rule: any, value: any, callback: any) {
    if (this.enterImgUpload && this.enterImgUpload.length > 0) {
      return callback();
    }
    return callback(new Error('请选择游戏入口图'));
  }
  getGameId(rule: any, value: any, callback: any) {
    if (this.model.game_id > 0) {
      return callback();
    }
    return callback(new Error('请选择游戏ID'));
  }

  async editHandle() {
    (this.$refs.hotForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true;
          this.model.enter_img = this.enterImgUpload[0].url; //入口图
          if (this.enterImg2Upload.length > 0) {
            this.model.enter_img2 = this.enterImg2Upload[0].url; //入口图2
          }
          let res: any;
          const isAdd: boolean = this.model && this.model.id > 0;
          this.$msgbox({
            title: '提示',
            message: !isAdd ? '请仔细检查配置内容，确认提交后，需要发布才能生效!' : '修改内容不会马上生效，需要点击发布后，才会生效!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: async (action, instance, done) => {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                if (isAdd) {
                  res = await postEditHostGame(this.model);
                } else {
                  res = await postAddHostGame(this.model);
                }
                done();
                if (res.code == 0) {
                  if (isAdd) {
                    toast('修改成功');
                  } else {
                    toast('添加成功');
                  }
                  (this.$refs.hotForm as ElForm).resetFields();
                  setTimeout(() => {
                    this.$emit('editOk');
                  }, 800);
                } else {
                  toast(res.msg, 'error');
                }
                instance.confirmButtonLoading = false;
                this.loading = false;
              } else if (action === 'cancel') {
                done();
                instance.confirmButtonLoading = false;
                this.loading = false;
              }
            },
          })
            .then(action => {})
            .catch(err => {
              console.log(err);
              this.loading = false;
            });
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
    });
  }

  cancel() {
    //  this.$emit('close');
    this.$emit('editOk');
  }
  async getGame() {
    const item: iSelectGame = {
      source: 'select',
      page_size: 1000,
      act_free: -1,
    };
    const res: any = await getGameManage(item);
    // console.log(item, res);

    if (res.code == 0) {
      this.gameList = res.data.list;
      this.gameList.unshift({
        name: '请选择游戏',
        id: -1,
      });
    }
  }
  mounted() {
    // console.log(this.model);

    this.getGame();
  }
}
